import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9h8","key":"svg-0"}],["path",{"d":"M8 13h6","key":"svg-1"}],["path",{"d":"M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8","key":"svg-2"}],["path",{"d":"M16 19h6","key":"svg-3"}]]

const IconMessage2Minus = createReactComponent('outline', 'message-2-minus', 'Message2Minus', __iconNode);

export default IconMessage2Minus;